import {ConfigService, ErrorsService, Crop, ModelsList, StoreService} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class CropService extends StoreService<Crop> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Crop);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<Crop>> {
    return this.http.get<ModelsList<Crop>>(this.config.apiVerUrl('/app/crops'), {params: queryParams});
  }

  protected insert(values: Crop): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/crops'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/crops/${id}`));
  }

  protected update(id, values: Crop): Observable<Crop> {
    return this.http.put<Crop>(this.config.apiVerUrl(`/app/crops/${id}`), values);
  }

  get(id): Observable<Crop> {
    return this.http.get<Crop>(this.config.apiVerUrl(`/app/crops/${id}`));
  }

  loadAll(): Observable<ModelsList<Crop>> {
    return this.http.get<ModelsList<Crop>>(this.config.apiVerUrl('/app/crops'));
  }
}
